import {Component} from '@angular/core';
import {environment} from '../../environments/environment';
import {RouterOutlet} from "@angular/router";

@Component({
    selector: 'app-errors',
    templateUrl: './errors.component.html',
    imports: [
        RouterOutlet
    ],
    styleUrl: './errors.component.scss'
})
export class ErrorsComponent {

    environment = environment;

}
